export default __webpack_public_path__ + "static/media/img_card_1.7d33aaa9.svg";